import { Avatar, AvatarFallback, AvatarImage } from '@monksflow/monks-ui';

import { microInteraction } from '@/shared/ui/MicroInteractions';
import { getInitials } from '@/shared/utils/getInitials';
import { useTranslation } from 'react-i18next';

export interface OwnerInfo {
  name: string;
  avatarUrl: string | null;
  isMe: boolean;
}

interface OwnerCellProps {
  owner: OwnerInfo;
}

export const OwnerCell = ({ owner }: OwnerCellProps) => {
  const { t } = useTranslation('common');
  return (
    <div className="flex items-center gap-2 min-w-0">
      <Avatar
        data-testid="owner-cell-avatar"
        className={`size-8 shrink-0 ${microInteraction.avatar}`}
      >
        {owner.avatarUrl && <AvatarImage src={owner.avatarUrl} alt={owner.name} />}
        <AvatarFallback>{getInitials(owner.name)}</AvatarFallback>
      </Avatar>
      <span className="truncate text-sm">
        {owner.isMe ? t('components.ownerCell.me') : owner.name}
      </span>
    </div>
  );
};

OwnerCell.displayName = 'OwnerCell';
